import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { IPoint } from '@foblex/2d';
import { Response } from '../../shared/models/response.model';
import { Étape } from '../models/étape.model';
import { EtapeCreateRequest } from './requests/create-request';
import { EtapeUpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class EtapeService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/étapes';

  trouveParId(idEtape: string): Observable<Étape> {
    return this.#http.get<Étape>(this.BASE_URL + '/' + idEtape);
  }

  downloadParId(idEtape: string): Observable<Blob> {
    return this.#http.get(this.BASE_URL + '/download/' + idEtape, {
      responseType: 'blob' as const,
    });
  }

  trouverTous(idParcours: string) {
    return this.#http.get<Response<Étape>>(this.BASE_URL, { params: { idParcours } });
  }

  créer(data: EtapeCreateRequest) {
    return this.#http.post<Étape>(this.BASE_URL, data);
  }

  modifier(data: EtapeUpdateRequest) {
    return this.#http.put<void>(this.BASE_URL, data);
  }

  supprimer(id: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + id);
  }

  dupliquer(idÉtapeSource: string, idParcours: string, coords: IPoint, forceOverwrite: boolean = false) {
    return this.#http.post<Étape>(this.BASE_URL + '/duplication/' + idÉtapeSource, {
      idParcours,
      coords,
      forceOverwrite,
    });
  }
}
